module.exports = __webpack_public_path__ + "static/media/sprig.f74322d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/sprig.png
// module id = 88
// module chunks = 0